import React from 'react';
import TopBarADM from '../TopBar/TopBarADM';
import './Layout.css';
import { Outlet } from 'react-router-dom';

export default function LayoutADM() {
  return (
    <div className="layout-container">
      <TopBarADM />
      <div className="layout-content">
        <Outlet />
      </div>
    </div>
  );
} 